import React, { useEffect, useState } from "react";

export const MgidInArticleAd = () => {
  const [userType, setUserType] = useState("F");

  useEffect(() => {
    if (global.userPromise) {
      global.userPromise.catch(() => ({})).then(user => {
        const type = (user && user.userType) || "F";
        setUserType(type);
      });
    }
  }, []);

  const isPremium = userType === "P" || userType === "T" || userType === "R";

  if (isPremium) return null;

  return (
    <div>
      <div data-type="_mgwidget" data-widget-id="1808485" />
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,q){w[q]=w[q]||[];w[q].push(["_mgc.load"])})(window,"_mgq");`
        }}
      />
    </div>
  );
};
